/**
 * Data Explorer view-config registry. Mirrors the exception registry's
 * lookup role for the three browse views.
 */
import type { DataExplorerViewConfig, DataViewKey } from './types'
import { salesViewConfig } from './salesViewConfig'
import { productsViewConfig } from './productsViewConfig'
import { clientsViewConfig } from './clientsViewConfig'

const VIEW_CONFIGS: Record<DataViewKey, DataExplorerViewConfig> = {
  sales: salesViewConfig,
  products: productsViewConfig,
  clients: clientsViewConfig,
}

export const getDataExplorerViewConfig = (
  viewKey: DataViewKey,
): DataExplorerViewConfig => VIEW_CONFIGS[viewKey]

export type { DataExplorerViewConfig, DataViewKey, DataViewFacets } from './types'
export { SORT_KEY_MAP, toApiSortKey } from './types'
